{
  "about": "Machine-readable manifest of every third-party or generated media asset shipped in dist/. `npm run verify` fails if a shipped media file is missing here. Human-readable version: CREDITS.md.",
  "assets": [
    {
      "pattern": "^assets/barlow-condensed-latin-[0-9]+-(normal|italic)(-[A-Za-z0-9_-]{8})?\\.woff2?$",
      "title": "Barlow Condensed (latin subset)",
      "author": "Jeremy Tribby",
      "source": "https://github.com/jpt/barlow via @fontsource/barlow-condensed",
      "licence": "SIL Open Font License 1.1"
    },
    {
      "pattern": "^assets/model(-[A-Za-z0-9_-]{8})?.glb$",
      "title": "Arden Kite R2 car model (exterior, interior, wheels, livery texture)",
      "author": "This project — generated by tools/blender/build_car.py in Blender 5.2 (via the Blender MCP / headless)",
      "source": "tools/blender/build_car.py",
      "licence": "Original work for this project (CC0 1.0); door/rear lettering are mesh outlines of Blender's bundled DejaVu Sans font (Bitstream Vera licence permits embedding)"
    },
    {
      "pattern": "^assets/codriver(-[A-Za-z0-9_-]{8})?\\.glb$",
      "title": "Co-driver figure (rigged: suit, helmet, HANS, harness, tablet)",
      "author": "This project — generated by tools/blender/build_codriver.py in Blender 5.2",
      "source": "tools/blender/build_codriver.py",
      "licence": "Original work for this project (CC0 1.0)"
    },
    {
      "pattern": "^assets/audio/codriver\\.mp3$",
      "title": "Co-driver voice sprite (64 pace-note tokens)",
      "author": "Generated for this project with ElevenLabs (model eleven_v4, voice library voice \"Ben Flowers\"); cut, verified and packed by tools/voice/voice.mjs",
      "source": "tools/voice/phrases.json, tools/voice/clips.json, tools/voice/check-result.json",
      "licence": "ElevenLabs generated audio, used under the ElevenLabs Terms of Service with attribution (\"Voice generated with ElevenLabs\")"
    },
    {
      "pattern": "^assets/gravel_road_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Gravel Road (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Amal Kumar / Poly Haven",
      "source": "https://polyhaven.com/a/gravel_road",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/gravel_loose_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Gravel Floor (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Jenelle van Heerden, Matterfield / Poly Haven",
      "source": "https://polyhaven.com/a/gravel_floor",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/tarmac_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Road Damaged (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Dimitrios Savva / Poly Haven",
      "source": "https://polyhaven.com/a/road_damaged",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/mud_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Brown Mud 02 (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Rob Tuytel / Poly Haven",
      "source": "https://polyhaven.com/a/brown_mud_02",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/forest_floor_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Forest Leaves 04 (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Rob Tuytel / Poly Haven",
      "source": "https://polyhaven.com/a/forest_leaves_04",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/grass_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Leafy Grass (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Charlotte Baglioni / Poly Haven",
      "source": "https://polyhaven.com/a/leafy_grass",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/rock_(albedo|nrm)(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Texture: Rock Face 03 (repacked to WebP: albedo with AO, normal XY + roughness)",
      "author": "Dario Barresi, Rico Cilliers / Poly Haven",
      "source": "https://polyhaven.com/a/rock_face_03",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/spruce_branch_card(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Spruce branch card + bark strip (composited by tools/assets/foliage-cards.mjs)",
      "author": "Composite by this project from Poly Haven Fir Tree 01 twig maps (Rob Tuytel, Rico Cilliers) and Pine Bark (Dimitrios Savva)",
      "source": "https://polyhaven.com/a/fir_tree_01, https://polyhaven.com/a/pine_bark",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/grass_clump_card(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Grass clump card (composited by tools/assets/foliage-cards.mjs)",
      "author": "Composite by this project from Poly Haven Grass Medium 02 (Rico Cilliers)",
      "source": "https://polyhaven.com/a/grass_medium_02",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/fern_card(-[A-Za-z0-9_-]{8})?\\.webp$",
      "title": "Fern frond atlas",
      "author": "Rob Tuytel, Rico Cilliers / Poly Haven",
      "source": "https://polyhaven.com/a/fern_02",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(stones|impact|bottoming|splash|forest|crowd-cheer|crowd-murmur)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Sound effects: stones on the underbody, tree impact, suspension bottoming, water splash, forest ambience loop, spectators cheering and murmuring",
      "author": "Generated for this project with ElevenLabs sound effects (eleven_text_to_sound_v2); trimmed, normalised and looped by tools/audio/sfx.mjs",
      "source": "tools/audio/sfx.mjs (prompts in DECISIONS.md, M7 and P1-6)",
      "licence": "ElevenLabs generated audio, used under the ElevenLabs Terms of Service with attribution (\"Sound effects generated with ElevenLabs\")"
    },
    {
      "pattern": "^assets/engine-bank(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Recorded engine bank: real firing events of a full-throttle dyno pull and of an idle",
      "author": "dezoris (Freesound 183654, \"DynoJet Scion FR-S\") and ulose2piranha (Freesound 273334, \"WRX - Exhaust sounds\"); cycle-tracked and packed by tools/audio/engine-bank.ts",
      "source": "https://freesound.org/s/183654/ · https://freesound.org/s/273334/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/als-[1-6](-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Anti-lag bangs (six real pops)",
      "author": "modusmogulus (Freesound 797835, \"Car Antilag (No cleanup, 32float)\"); cut by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/797835/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-gravel-fast(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Gravel at speed (tyres and stones on a dirt road), loop",
      "author": "felix.blume (Freesound 685233, \"Car driving at fast speed on dirt road, recorded with microphone through the window\"); filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/685233/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-gravel-slow(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Gravel crunch at low speed (close to a tyre), loop",
      "author": "TRP (Freesound 577504, \"car tire on gravel rear cu blyth 21 6 12\"); filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/577504/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/dump-valve(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Turbo dump-valve blow-off",
      "author": "Generated for this project with ElevenLabs sound effects (eleven_text_to_sound_v2); cut and shaped by tools/audio/real-sfx.ts",
      "source": "tools/audio/real-sfx.ts (prompt in DECISIONS.md, audio realism)",
      "licence": "ElevenLabs generated audio, used under the ElevenLabs Terms of Service with attribution (\"Sound effects generated with ElevenLabs\")"
    },
    {
      "pattern": "^assets/surf-gravel-slide(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Sliding on loose gravel / dirt skid, loop",
      "author": "craigsmith (Freesound 675282, \"S36-15 Car skids; dirt\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/675282/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-tarmac-roll(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Tyres rolling on tarmac (no engine), loop",
      "author": "petruchio_ru (Freesound 188507, \"Tires car without an engine.\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/188507/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-tarmac-squeal(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Tyre squeal on tarmac, loop",
      "author": "audible-edge (Freesound 71738, \"Chrysler LHS tire squeal 03 (04-25-2009).wav\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/71738/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-mud(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Tyres churning through mud, loop",
      "author": "kyles (Freesound 637197, \"auto truck real start and drive pull away through mud\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/637197/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-water(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Driving through standing water, loop",
      "author": "bengomori (Freesound 381698, \"16_Car driving through burst water main on Wilton Way\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/381698/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-wind(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Wind noise at speed, loop",
      "author": "FunWithSound (Freesound 439242, \"Car Strong Wind Noise\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/439242/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/stone-([1-9]|10)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Stones hitting the underbody (ten real hits)",
      "author": "kyles (Freesound 637192, \"auto truck int driving on dirt road +small rocks hitting bottom of car\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/637192/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/crash-1(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Car crash impact",
      "author": "PauliusI (Freesound 346299, \"Car Crash_EXT\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/346299/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/wood-[1-3](-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Wood / tree trunk impacts",
      "author": "Profispiesser (Freesound 550918, \"FXSaSc Wood Tree Trunk Impact Ground Forest 5 Variants\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/550918/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/thud-1(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Landing / suspension bottoming thud",
      "author": "7of9Designs (Freesound 640204, \"Heavy Metal Thud on Ground\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/640204/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/splash-real(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Water splash (car through a puddle)",
      "author": "Milkybread (Freesound 830376, \"Cars running over puddles\"); cut, filtered and looped by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/830376/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^og.jpg$",
      "title": "Preview image (Open Graph / Twitter card): in-game screenshot",
      "author": "This project — rendered in the game by tools/og-shot.mjs",
      "source": "tools/og-shot.mjs",
      "licence": "Original work for this project (CC0 1.0)"
    },
    {
      "pattern": "^assets/(thump-[1-2])(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Suspension thumps over a speed bump (front and rear wheel, exterior)",
      "author": "menfa (Freesound 837875, \"car_speedbump_tacoya_bar_y_taqueria\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/837875/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(thump-3|knock-3|bumpstop-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Heavy pothole thump, sharp knock and bump-stop slam (inside a van)",
      "author": "kyles (Freesound 455823, \"ride inside mostly empty delivery truck heavy pothole chain rattles and back door open close.flac\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/455823/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(thump-4|knock-[1-2])(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Suspension thump and clunks on pothole-filled pavement (inside a small car)",
      "author": "buddhafish (Freesound 327718, \"Interior Prius driving rough road w rattles.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/327718/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(land-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Landing after a jump (a rally car landing heavily on dirt)",
      "author": "Pól (Freesound 385933, \"S019_Landing_Impact_Mono.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/385933/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(hit-rock-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Collision with a boulder (a rally car colliding with a rock face)",
      "author": "Pól (Freesound 385938, \"S020_Rock_Impact_Mono.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/385938/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(hit-metal-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Collision with a sign or arch post (a rally car colliding with a metal surface)",
      "author": "Pól (Freesound 385937, \"S021_Metal_Impact_Mono.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/385937/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(tap-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Light contact (a rally car touching a plastic barrier)",
      "author": "Pól (Freesound 385940, \"S022_Plastic_Impact_Mono.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/385940/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(scrape-loop)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Body scraping along an obstacle (a rally car scraping along a metal rail barrier)",
      "author": "Pól (Freesound 385939, \"S023_Metal_Rail_Scrape_Mono.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/385939/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(hit-barrier-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Collision with a concrete barrier or wall (an impact or crash into metal)",
      "author": "RichieMcMullen (Freesound 386798, \"metal_collision.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/386798/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(hit-tree-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Collision with a tree (a car skidding into a tree)",
      "author": "craigsmith (Freesound 675916, \"S36-11 Car in; skids; crashes into tree.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/675916/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(hit-fence-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Collision with a fence, rail or log (a car crashing through a wooden fence)",
      "author": "craigsmith (Freesound 675847, \"S36-10 Old rattling car crashes through wooden fence.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/675847/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(hit-bale-[1-2]|hit-bank-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Collision with a straw bale or an earth bank (a heavy bag dropped on dirt and dry leaves)",
      "author": "burbujafilms (Freesound 392008, \"HEAVY BAG DROP DIRT.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/392008/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(tap-wood-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Light knock against a wooden post (a knock on wood)",
      "author": "sukondi (Freesound 553886, \"Smash Sound Effect | Smash/knock wood\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/553886/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(belly-[1-3])(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "Underbody grounding (metal scraped over a hard surface, darkened)",
      "author": "deerlord (Freesound 534851, \"MetalScrape_6.wav\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/534851/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/(splash-small-1)(-[A-Za-z0-9_-]{8})?\\.mp3$",
      "title": "A tyre into a puddle (the start of a car through a road puddle)",
      "author": "Milkybread (Freesound 830376, \"Cars running over puddles\"); cut and levelled by tools/audio/real-sfx.ts",
      "source": "https://freesound.org/s/830376/",
      "licence": "CC0 1.0"
    },
    {
      "pattern": "^assets/surf-grass(-[A-Za-z0-9_-]{8})?.mp3$",
      "title": "Tyres rolling on long grass (loop)",
      "author": "Generated for this project with ElevenLabs sound effects (eleven_text_to_sound_v2); cut and levelled by tools/audio/real-sfx.ts",
      "source": "tools/audio/real-sfx.ts (prompts in DECISIONS.md, coordinated effects)",
      "licence": "ElevenLabs generated audio, used under the ElevenLabs Terms of Service with attribution (\"Sound effects generated with ElevenLabs\")"
    }
  ]
}
